import { Pipe, PipeTransform } from '@angular/core';
import { Materials } from 'app/shared/constants/materials';


@Pipe({
    name: 'getMaterialsType',
    standalone: true
})
export class GetMaterialsTypePipe implements PipeTransform {
  transform(materials: string[] ): string[] {
    const labels: string[] = Materials.filter(mt => mt.children.some(sb => materials.includes(sb.value))).map(m => m.label);
    return labels ;
  }
}
